export const getCabinBaggageCount = (cabinBaggage = {}, cabinBagageQuantity, luggageMaxCount) => {
	if (!cabinBaggage) {
		return 0;
	}

	if (cabinBaggage.included === true) {
		return luggageMaxCount;
	}

	if (cabinBaggage.included === false && cabinBaggage.canBeBooked === false) {
		return 0;
	}

	return cabinBagageQuantity || 0;
};

export const getBaggageCount = (flightBagageOption = {}, baggageQuantity, luggageMaxCount) => {
	if (flightBagageOption.quantity) {
		return flightBagageOption.quantity;
	}

	// Question: Does it mean that if a luggage is included we cannot add more ?
	if (flightBagageOption.included === true) {
		return luggageMaxCount;
	}

	if (flightBagageOption.included === false && flightBagageOption.canBeBooked === false) {
		return 0;
	}

	return baggageQuantity || 0;
};
